import { ViewModel,View } from "binder"
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { ServerConnection } from "src/server/serverConnection";
import { IGateway, IReceiveInfoProvider } from "../IGateway";
import  { CashGatewayView } from "./cashGateway-view"
import { translate } from "src/common/utilities";

export class CashGatewayViewModel extends ViewModel implements IGateway{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.title = translate("cashGateway-viewModel.cash",{});
    }
    initialLoad() {
        this.district = new DistrictSelector(this);
    }
    GetDefaultView(): View <ViewModel> {
        return new CashGatewayView();
    }
    public getTypeId(): string {
        return "VM-D51C6C78-B41C-458D-A212-A148FECB4D8B"
    }
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set district(v: DistrictSelector) { this._district = v; } public get district(): DistrictSelector { return this._district;} private _district: DistrictSelector;
    
    async save(dataProvider: IReceiveInfoProvider): Promise<any> {
        return await ServerConnection.callServer('Complex/ArapServices/CreateCashReceivable',{
            ReceivableInfo:dataProvider.getBaseReceivableInfoDto(),
            DistrictId:this.district.selectedItem.id
        });
    }
    validate(): string[] {
        if(this.district.selectedItem==null){
            return [translate("cashGateway-viewModel.cashBox",{})] 
        }
        return [];
    }

}
